import React from "react";
import { colour } from "../style/base-theme";

export default function AxisLabel(props) {
  const {
    payload: { value },
    textAnchor,
    y,
    x
  } = props;

  const twoDigit = value.slice(0, 2);
  let hour = Number(twoDigit);
  if (hour > 12) {
    hour -= 12;
  }
  if (hour === 0) {
    hour = 12;
  }
  return (
    <text
      fill={colour.grey[300]}
      fontWeight={600}
      fontSize={12}
      textAnchor={textAnchor}
    >
      <tspan x={x + 1} y={y + 4}>
        {hour}
        {twoDigit < 12 || value === "2400" ? "am" : "pm"}
      </tspan>
    </text>
  );
}
